import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { format } from 'date-fns';
import { getCurrencyString } from '../../utils/InputUtils';

const styleSheet = theme => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing(1),
    overflow: 'auto',
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  },
  tblHeadCell: {
    textAlign: 'center',
    verticalAlign: 'bottom',
    borderBottom: 0,
  },
  tblCellWidth100: {
    width: 100,
  },
  tblCellPositive: {
    textAlign: 'right',
    color: '#006400'
  },
  tblCellNegative: {
    textAlign: 'right',
    color: 'red'
  },
  appnameitem: {
    marginLeft: 8,
  },
  [theme.breakpoints.up('sm')]: {
    tblCellDateCol: {
      paddingleft: 10,
      paddingright: 10,
      width: 50,
    },
    tblCellAppCol: {
      paddingleft: 10,
      paddingright: 10,
      minWidth: 200,
      width: 250,
    }
  },
  [theme.breakpoints.up('xs')]: {
    tblCellDateCol: {

    },
    tblCellAppCol: {

    }
  },

});

class PayoutsList extends React.Component {

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.pl.nodes;
    
    return (
      <div className={classes.paper}>
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell>Initiated date</TableCell>
                <TableCell>Completed date</TableCell>
                <TableCell align='right'>Amount</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {thenodes.map((n, index) => {

                //fake date data for the purpose of displaying something, tbd what the nodes do later.
                let theType = ''; 
                if (n.transactionType === 11)
                  theType = 'Manual';
                //dont know which number for transaction type will be manual, tbd
                if (n.transactionType !== 11)
                  theType = 'Automatic';

                let theStatus = '';
                if (n.paymentStatus === 0)
                  theStatus = 'Paid';
                if (n.paymentStatus === 1)
                  theStatus = 'In transit';


                let initiated = '';
                if (n.initiatedTime != null)
                  initiated = format(new Date(n.initiatedTime), 'yyyy-MM-dd');

                let completed = '';
                if (n.completedTime != null)
                  completed = format(new Date(n.completedTime), 'yyyy-MM-dd');

                return (
                  <TableRow key={index}>
                    <TableCell>{initiated}</TableCell>
                    <TableCell>{completed}</TableCell>
                    <TableCell align='right'>{getCurrencyString(n.payoutAmt)}</TableCell>
                    <TableCell>{theType}</TableCell>
                    <TableCell>{theStatus}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );

  } // end render()
}

PayoutsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(PayoutsList), {
  pl: graphql`
  fragment PayoutsList_pl on ResellerPayoutResultsConnection {
    nodes {
      transactionId
      transactionType
      initiatedTime
      completedTime
      payoutAmt
      payoutFees
      paymentStatus
      paymentStatusReason
      psType
    }
  }
`});